export const hasCreateProjectPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return validatePermission(userEntitlements?.primaryPartyType, userEntitlements?.dataPermissions?.energyFlowProjects?.create);
    }
};
export const hasUpdateProjectPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return validatePermission(userEntitlements?.primaryPartyType, userEntitlements?.dataPermissions?.energyFlowProjects?.update);
    }
};
export const validatePermission = (primaryPartyType, permission) => {
    const hasPermission = primaryPartyType?.toUpperCase() === "CAT" && permission !== undefined;
    return hasPermission;
};
export const getUserPartyNumber = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return "";
    }
    else {
        const permission = userEntitlements?.dataPermissions?.energyFlowProjects?.view;
        const partyFilter = permission?.filterConditions.filter((fc) => fc?.partyNumbers !== undefined);
        return partyFilter?.[0]?.partyNumbers?.[0];
    }
};
// This function checks if the user is a CAT admin user with create permission for energy flow links
export const isCatAdminUserEnergyFlowLinks = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return (userEntitlements?.dataPermissions?.energyFlowLinks?.create !== undefined &&
            userEntitlements?.primaryPartyType?.toUpperCase() === "CAT");
    }
};
export const hasEnergyFlowLinksCreatePermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.create !== undefined;
    }
};
export const hasEnergyFlowLinksUpdatePermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.update !== undefined;
    }
};
export const hasEnergyFlowLinksViewPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    else {
        return userEntitlements?.dataPermissions?.energyFlowLinks?.view !== undefined;
    }
};
// Strict variant for security-sensitive actions (e.g., charger controls)
// that must require an explicit entitlement and must not rely on legacy
// permissive fallbacks.
export const hasStrictEnergyFlowLinksViewPermission = (userEntitlements) => {
    if (userEntitlements === undefined || userEntitlements?.dataPermissions === undefined) {
        return false;
    }
    return userEntitlements?.dataPermissions?.energyFlowLinks?.view !== undefined;
};
